export enum UpdateInstallSeverity {
	Critical = 'Critical',
	Recommended = 'Recommended',
	Optional = 'Optional'
}
